import { render, staticRenderFns } from "./order-page.vue?vue&type=template&id=39eb8b7a&scoped=true"
import script from "./order-page.vue?vue&type=script&lang=ts"
export * from "./order-page.vue?vue&type=script&lang=ts"
import style0 from "./order-page.vue?vue&type=style&index=0&id=39eb8b7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39eb8b7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39eb8b7a')) {
      api.createRecord('39eb8b7a', component.options)
    } else {
      api.reload('39eb8b7a', component.options)
    }
    module.hot.accept("./order-page.vue?vue&type=template&id=39eb8b7a&scoped=true", function () {
      api.rerender('39eb8b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "orders/order-page.vue"
export default component.exports